<template>
  <v-card
    class="mx-auto"
    color="grey lighten-4"
    max-width="800"
  >
    <v-card-title>
      <v-icon
        :color="checking ? 'red lighten-2' : 'indigo'"
        class="mr-5"
        size="64"
        @click="takePulse"
      >
        mdi-glass-mug-variant
      </v-icon>
      <v-layout
        column
        align-start
      >
        <div class="caption black--text text-uppercase">
          Quarantine Beer Collection
        </div>
      </v-layout>

      <v-spacer></v-spacer>
    </v-card-title>

    <v-sheet color="transparent">
      <v-data-table
      :headers="headers"
      :items="beers"
      :items-per-page="25"
      class="elevation-1"
      ></v-data-table>
    </v-sheet>
  </v-card>
  <!-- <v-sparkline
    :value="value"
    :gradient="gradient"
    :smooth="radius || false"
    :padding="padding"
    :line-width="width"
    :stroke-linecap="lineCap"
    :gradient-direction="gradientDirection"
    :fill="fill"
    :type="type"
    :auto-line-width="autoLineWidth"
    auto-draw
  ></v-sparkline>
  </div> -->
</template>
<script>
export default {
    data () {
      return {
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Type', value: 'type' },      
          { text: 'ABV', value: 'abv' },
          { text: 'Region', value: 'region' },
          { text: 'Rating', value: 'rating' },
          { text: 'Notes', value: 'notes',
            sortable: false },
        ],
        beers: [
          {
            name: 'Partake Blonde Ale',
            type: "Blonde",
            abv: 0.2,
            region: "Toronto, Canada",
            rating: 45,
            notes: "Near-beer. Gets close to the real thing, but tastes too watered down."
          },
          {
            name: 'Marathon Run Wild',
            type: "IPA",
            abv: 0.5,
            region: "Stratford, CT",
            rating: 20,
            notes: "Near-beer. Really hoppy but somehow still very bland."
          },
          {
            name: 'Oskar Blues Mama\'s Little Yella Pils',
            type: "Pilsner",
            abv: 4.7,
            region: "Austin, TX",
            rating: 66,
            notes: "Honey malt"
          },
          {
            name: 'Oskar Blues G\'Knight',
            type: "Double Red IPA",
            abv: 8.7,
            region: "Austin, TX",
            rating: 55,
            notes: ""
          },
          {
            name: 'Oskar Blues Dale\'s Pale Ale',
            type: "American Pale Ale",
            abv: 6.5,
            region: "Austin, TX",
            rating: 81,
            notes: "Best from this Brewery. Hops and Citrus combination tastes great."
          },
          {
            name: 'Oskar Blues One-y IPA',
            type: "Hazy IPA",
            abv: 4.0,
            region: "Austin, TX",
            rating: 58,
            notes: "100 Calories"
          },
          {
            name: 'Wild Acre Pinch & Twist',
            type: "Pale Ale",
            abv: 5.8,
            region: "Fort Worth, TX",
            rating: 78,
            notes: "Light lemon flavor, pairs well with Seafood "
          },
          {
            name: 'Tupps Juice Pack',
            type: "Pale Ale",
            abv: 5.5,
            region: "McKinney, TX",
            rating: 73,
            notes: "Fruit flavor blends well with dry hops"
          },
          {
            name: 'Tupps Full Grown Man-Child',
            type: "Imperial Double Stout",
            abv: 8.3,
            region: "McKinney, TX",
            rating: 65,
            notes: "Chocolate-coffee infused. Not as heavy or overbearing as other similar chocolate Stouts."
          },
           {
            name: 'Tupps IPA',
            type: "IPA",
            abv: 7.1,
            region: "McKinney, TX",
            rating: 80,
            notes: "Citrus-infused; not as hoppy"
          },
            {
            name: 'Tupps National Standard',
            type: "American Ale",
            abv: 5.2,
            region: "McKinney, TX",
            rating: 65,
            notes: ""
          },
           {
            name: 'Magic Hat #9',
            type: "Pale Ale",
            abv: 5.1,
            region: "Burlington, VT",
            rating: 52,
            notes: ""
          },
          {
            name: 'Smithwicks',
            type: "Red Ale",
            abv: 4.5,
            region: "Dublin, Ireland",
            rating: 70,
            notes: ""
          },
          {
            name: 'Firestone Walker 805',
            type: "Blonde Ale",
            abv: 4.7,
            region: "California",
            rating: 74,
            notes: ""
          },
           {
            name: 'Stone Tropic of Thunder',
            type: "Lager",
            abv: 5.8,
            region: "California",
            rating: 62,
            notes: ""
          },
          {
            name: 'Rogue Batsquatch',
            type: 'Hazy IPA',
            abv: 6.7,
            region: 'Oregon',
            rating: 70,
            notes: "Tropical Citrus"
          }
        ]
      }
    },
  }
</script>